// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const majorArcanaTarotCards1 = [
  {
    image_description: "A crowned figure holding scales and a sword, seated between pillars",
    id: 11,
    name_en: "Justice",
    name_hi: "न्याय",
    vedic_name: "Dharma Nyaya (Cosmic Justice)",
    vedic_parallel: "Like Yama, the lord of dharma — every action has its precise consequence",
    upright: {
      keywords: ["fairness", "truth", "law", "cause and effect", "accountability"],
      meaning: "Truth and fairness prevail. The consequences of past actions arrive now.",
      advice: "Act with integrity. Karma is precise — it misses nothing.",
    },
    reversed: {
      keywords: ["injustice", "dishonesty", "imbalance", "lack of accountability"],
      meaning:
        "Something is out of balance. Dishonesty or avoidance delays but does not escape justice.",
      advice: "Correct the imbalance before it corrects itself.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A figure suspended upside-down from a tree, expression serene",
    id: 12,
    name_en: "The Hanged Man",
    name_hi: "लटकता हुआ",
    vedic_name: "Viparita (The Reversal)",
    vedic_parallel: "Like the Vamana avatar — seeing the universe from an inverted perspective",
    upright: {
      keywords: ["surrender", "new perspective", "pause", "sacrifice", "letting go"],
      meaning: "Surrender brings clarity. Sometimes progress requires standing still.",
      advice: "Let go of control. The view changes when you stop struggling.",
    },
    reversed: {
      keywords: ["stalling", "resistance", "needless sacrifice", "indecision"],
      meaning: "You are delaying for no reason, or sacrificing without purpose.",
      advice: "If the pause has served its purpose, it is time to move.",
    },
    planet: "neptune",
    vedic_graha: "ketu",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A skeletal figure on a white horse, a rising sun in the distance",
    id: 13,
    name_en: "Death",
    name_hi: "मृत्यु",
    vedic_name: "Pralaya (The Dissolution)",
    vedic_parallel: "Like Shiva as Mahakala — destruction that clears the ground for new creation",
    upright: {
      keywords: ["transformation", "ending", "transition", "letting go", "renewal"],
      meaning: "An ending that makes space for rebirth. What dies was already complete.",
      advice: "Release what has served its purpose. New life waits on the other side.",
    },
    reversed: {
      keywords: ["resistance to change", "stagnation", "fear of endings", "decay"],
      meaning: "Clinging to what is already over. The refusal to let go creates suffering.",
      advice: "Accept the ending with grace. Resistance only prolongs the pain.",
    },
    planet: "pluto",
    vedic_graha: "ketu",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "An angel pouring water between two cups, one foot on land, one in water",
    id: 14,
    name_en: "Temperance",
    name_hi: "संतुलन",
    vedic_name: "Samatva (Equanimity)",
    vedic_parallel: "Like the middle path of Buddha — balance between extremes brings peace",
    upright: {
      keywords: ["balance", "moderation", "patience", "harmony", "purpose"],
      meaning: "Harmony through balance. Mix your energies with patience and purpose.",
      advice: "Find the middle path. Excess in any direction creates imbalance.",
    },
    reversed: {
      keywords: ["imbalance", "excess", "impatience", "misalignment"],
      meaning: "You have gone too far in one direction. Recalibrate before it costs you.",
      advice: "Step back and restore equilibrium. Healing comes from balance.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A horned figure on a pedestal, two chained figures below who could leave",
    id: 15,
    name_en: "The Devil",
    name_hi: "असुर",
    vedic_name: "Maya Bandhan (The Bondage of Illusion)",
    vedic_parallel: "Like Ravana's golden Lanka — attachment to material splendor that imprisons",
    upright: {
      keywords: ["bondage", "materialism", "addiction", "temptation", "shadow self"],
      meaning:
        "Something holds you captive — habit, desire, or fear. The chains are of your own making.",
      advice: "Recognize the illusion. Freedom begins with awareness.",
    },
    reversed: {
      keywords: ["release", "breaking free", "detachment", "reclaiming power"],
      meaning: "You are ready to break free from what has held you. The chains are loosening.",
      advice: "Walk away. What seemed impossible to leave is easier than you thought.",
    },
    planet: "saturn",
    vedic_graha: "shani",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A tower struck by lightning, figures falling, flames emerging",
    id: 16,
    name_en: "The Tower",
    name_hi: "मीनार",
    vedic_name: "Pralay Stambha (The Pillar of Destruction)",
    vedic_parallel:
      "Like the churning of the ocean — destruction that releases both poison and nectar",
    upright: {
      keywords: ["sudden upheaval", "revelation", "chaos", "breakthrough", "awakening"],
      meaning: "A sudden collapse of what was built on false foundations. Painful but necessary.",
      advice: "Let it fall. What is true will survive the storm.",
    },
    reversed: {
      keywords: ["avoidance of disaster", "fear of change", "delayed upheaval"],
      meaning:
        "You sense the crack in the foundation but refuse to act. The fall comes regardless.",
      advice: "Address the weakness now, or the collapse will be worse later.",
    },
    planet: "mars",
    vedic_graha: "mangal",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A woman kneeling by water, pouring from two vessels, stars shining above",
    id: 17,
    name_en: "The Star",
    name_hi: "तारा",
    vedic_name: "Tara (The Guiding Light)",
    vedic_parallel: "Like Dhruv Tara — the steadfast star that guides travelers through darkness",
    upright: {
      keywords: ["hope", "faith", "renewal", "inspiration", "serenity"],
      meaning: "After the storm, clarity returns. Hope is not naive — it is earned.",
      advice: "Trust the process. You have survived the worst and light returns.",
    },
    reversed: {
      keywords: ["despair", "disconnection", "lack of faith", "hopelessness"],
      meaning: "Hope feels distant. You may be focusing on what was lost instead of what remains.",
      advice: "Look up. The stars are still there even when clouds cover them.",
    },
    planet: "uranus",
    vedic_graha: "rahu",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A moon over a path between two towers, a dog and wolf howling",
    id: 18,
    name_en: "The Moon",
    name_hi: "चन्द्रमा",
    vedic_name: "Chandra Maya (Lunar Illusion)",
    vedic_parallel:
      "Like the moon's phases — reality shifts with perception, not everything is as it seems",
    upright: {
      keywords: ["illusion", "fear", "intuition", "the unconscious", "confusion"],
      meaning: "Things are not what they appear. Trust your intuition but verify your fears.",
      advice: "Wait for clarity. The full picture has not yet emerged.",
    },
    reversed: {
      keywords: ["release of fear", "clarity emerging", "overcoming confusion"],
      meaning: "The fog lifts. What confused you is becoming clear.",
      advice: "Act on the clarity that arrives. Do not return to old doubts.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A radiant sun above a child on a white horse, sunflowers blooming",
    id: 19,
    name_en: "The Sun",
    name_hi: "सूर्य",
    vedic_name: "Surya Prakash (Solar Radiance)",
    vedic_parallel:
      "Like Surya Devata illuminating the three worlds — truth that dispels all shadow",
    upright: {
      keywords: ["joy", "success", "vitality", "warmth", "clarity", "optimism"],
      meaning: "A time of clarity and joy. Success comes naturally when aligned with truth.",
      advice: "Step into the light. Your warmth uplifts everyone around you.",
    },
    reversed: {
      keywords: ["temporary setback", "lack of clarity", "dimmed joy"],
      meaning: "The light is there but temporarily obscured. Minor delays, not failure.",
      advice: "Be patient. The clouds pass and the sun returns stronger.",
    },
    planet: "sun",
    vedic_graha: "surya",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "An angel blowing a trumpet, figures rising from below with arms raised",
    id: 20,
    name_en: "Judgement",
    name_hi: "निर्णय",
    vedic_name: "Chitragupta Lekha (The Cosmic Reckoning)",
    vedic_parallel:
      "Like Chitragupta's ledger — the moment when all karmas are weighed and accounted",
    upright: {
      keywords: ["rebirth", "reckoning", "absolution", "calling", "inner voice"],
      meaning: "A call to rise. Past karmas are resolved and a higher purpose beckons.",
      advice: "Answer the call. This is the culmination of everything you have learned.",
    },
    reversed: {
      keywords: ["self-doubt", "refusal of calling", "harsh self-judgement"],
      meaning: "You are being too harsh on yourself, or refusing to hear your calling.",
      advice: "Forgive yourself. Growth requires accepting where you have been.",
    },
    planet: "pluto",
    vedic_graha: "ketu",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A dancing figure within a wreath, four creatures at the corners",
    id: 21,
    name_en: "The World",
    name_hi: "संसार",
    vedic_name: "Purna (The Complete)",
    vedic_parallel:
      "Like the Vishwarupa — the vision of totality where all cycles meet in completion",
    upright: {
      keywords: ["completion", "accomplishment", "integration", "wholeness", "travel"],
      meaning: "A cycle completes. You have arrived where you were meant to be.",
      advice: "Celebrate the completion. Then prepare for the next spiral.",
    },
    reversed: {
      keywords: ["incompleteness", "shortcuts", "delays", "unfulfillment"],
      meaning: "Something remains unfinished. The cycle cannot close until the lesson is learned.",
      advice: "Tie up loose ends. Completion requires attention to what you have avoided.",
    },
    planet: "saturn",
    vedic_graha: "shani",
    element: "earth",
    arcana: "major",
    suit: null,
  },
] as const satisfies readonly TarotReferenceCard[];
